module.exports = __webpack_public_path__ + "static/media/lawyer-hero.360bf206.svg";